export default [{
  path: '/bizs/albuquerque-hispano-chamber-of-commerce_albuquerque_nm',
  redirect: '/event/659f12883bfba60bfa35c3ee'
}, {
  path: '/505central',
  redirect: '/poi/505central-abq-nm-us'
}, {
  path: '/iheart',
  redirect: '/shop/iheart'
}]